import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { PopupComponent } from '../../network-visibility/popup/popup.component';
import { PopupDetailsComponent } from '../popup-details/popup-details.component';
declare const L: any;
import 'leaflet-draw';
import { LatLng, Layer } from 'leaflet';
import { get } from 'http';
import { interval, Subscription } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


// Fix for missing default marker icon in Angular builds
delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'assets/marker-icon-2x.png',
  iconUrl: 'assets/marker-icon.png',
  shadowUrl: 'assets/marker-shadow.png'
});

@Component({
  selector: 'app-ec-map',
  templateUrl: './ec-map.component.html',
  styleUrls: ['./ec-map.component.css']
})
export class EcMapComponent implements OnInit {

  isChecked = false;
  params:any = [];
  user: any;
  isFreeInternet: any = ""



  private map!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];
  deviceType: any =[]
  deviceGroup:any = []
  usersList: any= []
  routeData: any = [];
  search = ""
  latitude: any = "";
  longitude: any = "";
  LatLng: any = [];
  lat: any = "";
  lng: any = "";
  routeid: any = "";
  Data: any = [];
  singleRoute: any = [];
  groupTypeList:any = [];
  group:any = "";
  type:any = "";
  routeDetails:any = [];
  ECdata:any = []
  data: any = []
  customerData: any = []
  form: any | FormGroup
  form1: any | FormGroup

  agent = false;
  email = false;
  EmailInput = false;
  emailverify = false;
  sendOtp = "send otp";
  phone = false;
  PhoneInput = false;
  phoneverify = false;
  phoneotp = false;
  resendOtp = false;
  resendOtp1 = false;
  vemailOtp = '';
  vphoneOtp = '';
  Id = 0;
  id1 = 0;
  otpsend = false;
  timer = false;
  timer1 = false

  cDay: any
  dDay: any

  isEmailVerified = false;
  isPhoneVerified = false;
  url1 = '';
  url2 = '';
  url3 = '';
  imgUrl1 = ''
  imgUrl2 = ''
  imgUrl3 = ''
  file1: File | undefined;
  file2: File | undefined;
  file3: File | undefined;
  cid: any 

  photoUrl: any = ""
  idProofUrl: any = ""
  addressProofUrl: any = ""
  buildingUrl: any = ""

  photoUrlLoading: any = false
  idProofUrlLoading: any = false
  addressProofUrlLoading: any = false
  buildingUrlLoading: any = false


    location: any = ""
    locationList:any = [];
    objectInfoList:any = [];
    assetSelectedList:any = [];
    assetDropdownSettings: IDropdownSettings = {
      singleSelection: false,
      idField: 'objectInfoId',
      textField: 'givenName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  deviceInfoList:any = [
    {
      "deviceId": "",
      "deviceType": "",
      "deviceInfo": "",
      "devicePhotoUrl": "",
      "deviceLat": "",
      "deviceLng": "",
      "devicePhotoUrlLoading" : false
    }
  ]


  activeIcon = L.divIcon({
    className: '',
    html: `
      <div style="
        position: relative;
        width: 60px;
        height: 60px;
        background: white;
        border: 3px solid #4DF02D;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
<img src="assets/home-icon-illustration-design-vector.jpg" style="width: 100%; height: 100%; object-fit: cover;" />
        <div style="
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 15px solid #2c3e50;
        "></div>
      </div>
    `,
    iconAnchor: [30, 64],
    popupAnchor: [0, -60]
  });

  inActiveIcon = L.divIcon({
    className: '',
    html: `
      <div style="
        position: relative;
        width: 60px;
        height: 60px;
        background: white;
        border: 3px solid #FB232E;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
<img src="assets/home-icon-illustration-design-vector.jpg" style="width: 100%; height: 100%; object-fit: cover;" />
        <div style="
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 15px solid #2c3e50;
        "></div>
      </div>
    `,
    iconAnchor: [30, 64],
    popupAnchor: [0, -60]
  });


  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,private router: Router,
    private injector: Injector) {
      this.generic_service.customerView.subscribe((value) => {
        document.getElementById("viewB")?.click()
      });
     }

  ngOnInit(): void {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.cid = sessionStorage.getItem('cid');

    // this.getAllRoute();
    this.getAllObjectTypeAndGroup()
    // this.getRouteById(this.routeid)
    // this.initMap()
    // this.initMap2()
    this.getAllExistingCustomerInfo()
      this.form = this.fb.group({
      name: ['',[Validators.required]],
      mobileNo: ['', [Validators.required,
      Validators.pattern("^[0-9]{10,10}$")]],
      altMobileNo: [''],
      email: ['',[Validators.required]],
      // ['', [Validators.required,
      // Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      altEmail: [''],
      installationAddress: ['',[Validators.required]],
      idProofUrl: ['',[Validators.required]],
      photoUrl: ['',[Validators.required]],
      addressProofUrl: ['',[Validators.required]],
      customerId:['',[Validators.required]],
      deviceId:[''],
      deviceType:[''],
      deviceInfo:[''],
      applicationFormFor: ['',[Validators.required]],
      buildingUrl: ['',[Validators.required]],
      deviceInfoList:this.fb.array([]),
    });
      this.addDeviceInfoList()
      this.getAllObjectInfo()
      this.getAllLocation()

  }

  // addDeviceInfoList(){
  //   this.infoList.push(this.InfoObject())
  // }

  // removeDeviceInfoList(index: number){
  //   this.infoList.removeAt(index)
  // }

  

  private initMap(): void {

    let centroid1: L.LatLngExpression[]= [];

    if(this.routeData.length != 0) {
      for(let i=0; i<this.routeData.length; i++){
        let obj:L.LatLngExpression = [
          Number(this.routeData[i].Lat),
          this.routeData[i].Lng
        ]
        centroid1.push(obj)
      }
      let loc = 0;
      let zoom = 16
      if(localStorage.getItem('loc') != '' && localStorage.getItem('loc') != null && localStorage.getItem('loc') != undefined){
        loc = Number(localStorage.getItem('loc'))
        zoom = 20
      }

      this.map = L.map('map', {
        center: centroid1[0],
        zoom: zoom
      });
  
      const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        minZoom: 2,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      });
  
      L.Icon.Default.imagePath='/Users/thirumaleshmanche/Desktop/anikinitek/assetmgmtwebui/src/assets/57-576397_this-free-icons-png-design-of-location-marker.png';
  
      // create 5 random jitteries and add them to map
      this.data = []
      this.data.push(this.routeDetails[0])

      for(let i = 0; i < centroid1.length; i++){
        if(this.routeDetails[i].isActive){
          let markerPopup: any = this.compilePopup(PopupDetailsComponent,(c:any) => {c.instance.customData = this.routeDetails[i]});
          let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.activeIcon})
          // .bindPopup(
          //   markerPopup
          // ).openPopup()
          loc.addTo(this.map).on('click', () => this.onMarkerClick(this.routeDetails[i]));
        }else{
          let markerPopup: any = this.compilePopup(PopupDetailsComponent,(c:any) => {c.instance.customData = this.routeDetails[i]});
          let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.inActiveIcon})
          // .bindPopup(
          //   markerPopup
          // ).openPopup()
          loc.addTo(this.map).on('click', () => this.onMarkerClick(this.routeDetails[i]));
        }
     
      }
      tiles.addTo(this.map);
    }else{
      let loc = 0;
      let zoom = 12
      if(localStorage.getItem('loc') != '' && localStorage.getItem('loc') != null && localStorage.getItem('loc') != undefined){
        loc = Number(localStorage.getItem('loc'))
        zoom = 20
      }

      this.map = L.map('map', {
        center: [17.3850, 78.4867],
        zoom: zoom
      });
  
      const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        minZoom: 2,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      });
  
      tiles.addTo(this.map);
    }

    this.map.on('click', (event: L.LeafletMouseEvent) => {
      // this.placeMarker(event.latlng);
      // console.log(event.latlng)
      console.log("ok")
    });

    this.map.on('zoomend', () => {
      // this.updateMarkerIcon();
      console.log("ok")
    });


  }

  defaultIcon = L.icon({
    iconUrl: 'assets/map1.png', // your path may vary ...
    iconSize: [70, 70],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });


  getAllLocation(){
    this.generic_service.getAllLocation().subscribe(
      (res:any)=> {
        this.locationList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getAllObjectInfo(){
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        this.objectInfoList = response.response

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getExistingCustomerById(id:any){

    this.map.remove();
    this.routeid = id
    this.generic_service.getExistingCustomerById(id).subscribe(
      (response:any)=>{
        let sr:any = []
        this.singleRoute = []
        this.data = []

        this.singleRoute.push(response.response)
        this.data.push(response.response)

        for(let data of this.singleRoute) {
          let sn = 0;
          let Lat = data.lat;
          let Lng = data.lng;
          if(Lat != "" && Lat != "null" && Lat != "undefined" && Lat != null && Lat != undefined){
            let arr = {
              objectInfoId: data,
              existingCustomerInfoId: data.existingCustomerInfoId,
              name: String(data.name),
              serialNumber: String(sn),
              Lat: String(Lat),
              Lng: String(Lng),
            }
            sr.push(arr)
            this.routeDetails.push(data)
          }
        }

        let centroid1: L.LatLngExpression[]= [];

        if(sr.length != 0) {
    
          for(let i=0; i<sr.length; i++){
            let obj:L.LatLngExpression = [
              Number(sr[i].Lat),
              sr[i].Lng
            ]
            centroid1.push(obj)
          }
          let loc = 0;
          let zoom = 16
       
    
          this.map = L.map('map', {
            center: centroid1[0],
            zoom: zoom
          });
      
          const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            minZoom: 2,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          });
      
          L.Icon.Default.imagePath='https://www.iconpacks.net/icons/2/free-location-icon-2955-thumb.png';
      
          // create 5 random jitteries and add them to map
          
          for(let i = 0; i < centroid1.length; i++){
            let markerPopup: any = this.compilePopup(PopupDetailsComponent,(c:any) => {c.instance.customData = this.singleRoute[i]});
           let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup(
     
            markerPopup
           ).openPopup()
           loc.addTo(this.map)
          }
          tiles.addTo(this.map);
        }
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }


  getAllEC(){
    this.generic_service.getAllExistingCustomerInfo().subscribe(
      (response:any)=>{
        this.ECdata = response.response;
      }
    )
  }

  getAllExistingCustomerInfo(){
    this.generic_service.getAllExistingCustomerInfo().subscribe(
      (res:any)=> {
        // this.map.remove();
        this.routeDetails = []
        this.routeData = []
        console.log(res)
        for(let data of res.response) {
          let objectInfoId = data;

          let sn = 0;
          let Lat = data.lat;
          let Lng = data.lng;
          if(Lat != "" && Lat != "null" && Lat != "undefined" && Lat != null && Lat != undefined){
            let arr = {
              objectInfoId: objectInfoId,
              existingCustomerInfoId: data.existingCustomerInfoId,
              name: String(data.name),
              serialNumber: String(sn),
              isActive: data.isActive,
              Lat: String(Lat),
              Lng: String(Lng),
            }
            this.routeData.push(arr)
            this.routeDetails.push(data)
          }
        }
        console.log(this.routeData)
        console.log(this.routeDetails)

        this.initMap();

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getAllObjectTypeAndGroup(){
    this.generic_service.getAllObjectTypeAndGroup().subscribe(
      (res:any)=> {
        this.groupTypeList = res.response?.groupTypeList
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  onChoseLocation(){
    localStorage.removeItem('loc')
    location.reload();
  }

  singleLocation(index:any){
    localStorage.setItem('loc', index)
    location.reload();
  }

  selectGroupType(event:any) {
    this.group = this.groupTypeList[event.target.value].group,
    this.type = this.groupTypeList[event.target.value].type
  }

  compilePopup(component:any, onAttach:any): any {
    const compFactory: any = this.resolver.resolveComponentFactory(component);
    let compRef: any = compFactory.create(this.injector);

    // onAttach allows you to assign 
    if (onAttach)
      onAttach(compRef);

    this.appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));
    
    let div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }



  // initAddMap(): void {
  //   this.map = L.map('map', {
  //     center: this.defaultCenter,
  //     zoom: this.defaultZoom
  //   });

  //   const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //     maxZoom: 22,
  //     minZoom: 2,
  //     attribution: '&copy; OpenStreetMap contributors'
  //   });

  //   this.map.on('click', (event: L.LeafletMouseEvent) => {
  //     this.placeMarker(event.latlng);
  //   });

  //   tiles.addTo(this.map);
  // }

  isLatLng: any = false
  marker!: L.Marker;
  latlng: any = {
    lat: 0,
    lng: 0
  }
  defaultZoom: any = 8
  defaultCenter: L.LatLngExpression = [17.4051564, 78.4927618];




initMap1(): void {

  this.map = L.map('map1', {
    center: this.defaultCenter,
    zoom: this.defaultZoom
  });

  const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    minZoom: 2,
    attribution: '&copy; OpenStreetMap contributors'
  });

  this.map.on('click', (event: L.LeafletMouseEvent) => {
    this.placeMarker(event.latlng);
  });

  tiles.addTo(this.map);

  if (this.isLatLng) {
    this.marker = L.marker([this.latlng.lat, this.latlng.lng]).addTo(this.map);
  }
}

placeMarker(latlng: L.LatLng): void {
  this.isLatLng = true;
  this.latlng = latlng;

  if (this.marker) {
    this.map.removeLayer(this.marker);
  }

  this.marker = L.marker(latlng)
    .addTo(this.map)
}

  openMapPopup(): void {

    setTimeout(() => {
      this.initMap1();
      this.map.invalidateSize();
    }, 1000);
  }







  selectAgent(val: any) {
    if (val == 'Agent') {
      this.agent = true
    } else {
      this.agent = false
    }
  }

  verifyEmail() {
    let email = this.form.value.applicantEmailId
    const body = {
      "emailId": String(email)
    }

    this.email = true;
    this.EmailInput = true
    this.generic_service.ecGenerateEmailOtp(body).subscribe(
      (response: any) => {
        if (response.message == "Success") {
          this.Id = response.response
          this.toastr.success("please check your email for OTP");
          this.cDay = new Date();
          this.dDay = new Date(this.cDay.getTime() + (5 * 60 * 1000));
          this.subscription = interval(1000)
            .subscribe(x => { this.getTimeDifference(); });
          this.timer = true;
          this.otpsend = true
          this.resendOtp = false;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

    checked() {
    if (this.isChecked == false) {
      this.isChecked = true;
    }
    else {
      this.isChecked = false;
    }
  }

  verifyEmailOtp() {
    if (this.vemailOtp == '') {
      return
    }
    const body = {
      "phoneEmailVerificationId": Number(this.Id),
      "otp": String(this.vemailOtp)
    }
    this.generic_service.ecVerifyEmailOtp(body).subscribe(
      (response: any) => {
        if (response.message == "Success") {
          this.isEmailVerified = true
          this.toastr.success(response.response);
          this.email = false;
          this.emailverify = true
          this.timer = false
          this.ngOnDestroy()
        }
      },
      (err: any) => {
        console.log(err);
        this.toastr.error("Otp is incorrect");
      }
    );
  }

  verifyPhone() {
  
    let phone = this.form.value.mobileNo
    const body = {
      "phoneNo": String(phone),
      "cid" : this.cid
    }
    this.generic_service.ecGeneratePhoneOtp(body).subscribe(
      (response: any) => {
        if (response.message == "Success") {
          this.Id = response.response
          this.toastr.success("please check your phone for OTP");
          this.cDay = new Date();
          this.dDay = new Date(this.cDay.getTime() + (5 * 60 * 1000));
          this.subscription = interval(1000)
            .subscribe(x => { this.getTimeDifference1(); });
          this.timer1 = true;
          this.phoneotp = true
          this.resendOtp1 = false;
          this.phone = true;
          this.PhoneInput = true
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  phoneOtp() {
    if (this.vphoneOtp == '') {
      return
    }
    const body = {
      "phoneEmailVerificationId": Number(this.Id),
      "otp": String(this.vphoneOtp),
      "cid": this.cid
    }
    this.generic_service.ecVerifyPhoneOtp(body).subscribe(
      (response: any) => {
        if (response.message == "Success") {
          this.id1 = response.response
          this.isPhoneVerified = true
          this.phone = false;
          this.phoneverify = true
          this.PhoneInput = true
          this.timer1 = false
          this.ngOnDestroy()
        }
      },
      (err) => {
        console.log(err);
        this.toastr.error("Otp is incorrect");
      }
    );
  }


  onItemSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  async customerRegistration() {

    let shareLocation: any = localStorage.getItem('shareLocation')
    if(shareLocation == 'false' || shareLocation === false){

      this.toastr.error("Please allow location permission");
      return
    }

    if (!this.isPhoneVerified) {
      this.toastr.error("Please verify your phone number");
      return;
    }

    if (this.form.value.applicationFormFor != 'Cable') {
      this.isFreeInternet = ""
    }

    if (this.isChecked == true) {

      if(!this.form.valid){
        this.toastr.error("All star fields required");
        return
      }

      for(let list of this.deviceInfoList){
        delete list.devicePhotoUrlLoading
      }

      let location: any
      for(let list of this.locationList){
        if(list.zone == this.location){
          location = list
        }
      }

    let assetIdsWithTheirNames: any = []
    for(let list of this.assetSelectedList){
      let obj: any = {
        "assetId": list.objectInfoId,
        "assetName": list.assetName
      }
      assetIdsWithTheirNames.push(obj)
    }

      // let res1: any = await this.Generic_service.uploadImage(this.file1).toPromise()
      // this.imgUrl1 = res1.response
      
      // let res2: any = await this.Generic_service.uploadImage(this.file2).toPromise()
      // this.imgUrl2 = res2.response

      // let res3: any = await this.Generic_service.uploadImage(this.file3).toPromise()
      // this.imgUrl3 = res3.response

      const body = {
        "version": 0,
        "isActive": true,
        "description": this.isFreeInternet,
        "id": "",
        "existingCustomerInfoId": Number(this.id1),
        "customerId": this.form.value.customerId,
        "name": this.form.value.name,
        "info": "",
        "mobileNo": this.form.value.mobileNo,
        "altMobileNo": this.form.value.altMobileNo,
        "email": this.form.value.email,
        "altEmail": this.form.value.altEmail,
        "installationAddress": this.form.value.installationAddress,
        "photoUrl": this.photoUrl,
        "idProofUrl": this.idProofUrl,
        "addressProofUrl": this.addressProofUrl,
        "buildingUrl": this.buildingUrl,
        "applicationFormFor": this.form.value.applicationFormFor,
        "lat": localStorage.getItem('latitude'),
        "lng": localStorage.getItem('longitude'),
        "deviceInfoList": this.form.value.deviceInfoList,
        "locationObj": {
          "locationId": location.locationId,
          "country": location.country,
          "city": location.city,
          "provinceOrState": location.provinceOrState,
          "district": location.district,
          "zone": location.zone,
          "postalCode": location.postalCode
        },
        "assetIdsWithTheirNames": assetIdsWithTheirNames,
        "keyValuePairs": [],
        "latestStatus": "REQUESTED",
        "statusList": [
          {
            "note": "",
            "status": "REQUESTED",
            "updatedDate": 0
          }
        ],
        "cid": this.cid

      }
   
      this.generic_service.ecCustomerRegistration(body).subscribe(
        (response: any) => {

          this.form.reset();
          while (this.infoList.length) {
            this.infoList.removeAt(0);
          }
          this.addDeviceInfoList()
          this.toastr.success("Registration Successfull!!");


          this.agent = false;
          this.email = false;
          this.EmailInput = false;
          this.emailverify = false;
          this.sendOtp = "send otp";
          this.phone = false;
          this.PhoneInput = false;
          this.phoneverify = false;
          this.phoneotp = false;
          this.resendOtp = false;
          this.resendOtp1 = false;
          this.vemailOtp = '';
          this.vphoneOtp = '';
          this.location = ""
          this.assetSelectedList = []

          this.otpsend = false;
          this.timer = false;
          this.timer1 = false

          this.isEmailVerified = false;
          this.isPhoneVerified = false;
          this.isChecked = false;
          this.photoUrl = ""
          this.idProofUrl = ""
          this.addressProofUrl = ""
          this.buildingUrl = ""
          this.photoUrlLoading = false
          this.idProofUrlLoading = false
          this.addressProofUrlLoading = false
          this.buildingUrlLoading = false
          this.deviceInfoList = [
            {
              "deviceId": "",
              "deviceType": "",
              "deviceInfo": "",
              "devicePhotoUrl": "",
              "deviceLat": "",
              "deviceLng": "",
              "devicePhotoUrlLoading" : false
            }
          ]
          window.location.href = "/tabs/tab8"
        },
        (err) => {
          console.log(err);
          this.toastr.error(err.error.errors[0].description)
        }
      );

    }
    else {
      alert("Please accept terms and conditions");
    }
  }

  private subscription: Subscription = new Subscription;
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute = 60;
  public timeDifference: any;
  public secondsToDday: any;
  public minutesToDday: any;
  public hoursToDday: any;
  public daysToDday: any;

  private getTimeDifference() {
    this.timeDifference = this.dDay.getTime() - new Date().getTime();
    this.allocateTimeUnits(this.timeDifference);
    if (this.minutesToDday == 0 && this.secondsToDday == 0) {
      this.timer = false
      this.otpsend = true;
      this.resendOtp = true;
      this.ngOnDestroy()
    }
  }

  private getTimeDifference1() {
    this.timeDifference = this.dDay.getTime() - new Date().getTime();
    this.allocateTimeUnits(this.timeDifference);
    if (this.minutesToDday == 0 && this.secondsToDday == 0) {
      this.timer1 = false
      this.phoneotp = true;
      this.resendOtp1 = true;
      this.ngOnDestroy()
    }
  }

  private allocateTimeUnits(timeDifference: any) {
    this.secondsToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.SecondsInAMinute);
    this.minutesToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.SecondsInAMinute);
    this.hoursToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute) % this.hoursInADay);
    this.daysToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.map) {
      this.map.remove();
    }
  }
  
  size: number = 0

  onSelectFile(event: any) {
    this.file1 = event.target.files[0]
    this.size = Number(this.file1?.size)
    if (Math.abs(this.size / 1024) > 1024) {
      alert("Please select a file less than 1mb")
    }
    else {

      if (event.target.files) {
        var reader = new FileReader;
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (e: any) => {
          this.url1 = e.target.result

        }
      }
    }
  }

  onSelectFile1(event: any) {
    this.file2 = event.target.files[0]
    this.size = Number(this.file2?.size);
    if (Math.abs(this.size / 1024) > 1024) {
      alert("Please select a file less than 1mb");
    }
    else {

      if (event.target.files) {
        var reader = new FileReader;
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (e: any) => {
          this.url2 = e.target.result
        }
      }
    }
  }

  onSelectFile3(event: any) {
    this.file3 = event.target.files[0]
    this.size = Number(this.file2?.size);
    if (Math.abs(this.size / 1024) > 1024) {
      alert("Please select a file less than 1mb");
    }
    else {

      if (event.target.files) {
        var reader = new FileReader;
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (e: any) => {
          this.url3 = e.target.result
        }
      }
    }
  }






  removeImage(type:any){
    if(type == "photoUrl"){
      this.photoUrl = ""
      this.form.patchValue(
        {photoUrl : ""}
      )
    }

    if(type == "idProofUrl"){
      this.idProofUrl = ""
      this.form.patchValue(
        {idProofUrl : ""}
      )
    }

    if(type == "addressProofUrl"){
      this.addressProofUrl = ""
      this.form.patchValue(
        {addressProofUrl : ""}
      )
    }

    if(type == "buildingUrl"){
      this.buildingUrl = ""
      this.form.patchValue(
        {buildingUrl : ""}
      )
    }
  }

  addImageBtn(type:any){
    let photoType = type
    document.getElementById(photoType)?.click()
  }

  onChange(event: any,type:any) {
    // this.file = event.target.files[0];
    this.onUpload(event.target.files[0],type)
  }
  
  onUpload(file:any,type:any) {
    if(type == "photoUrl"){
      this.photoUrlLoading = true
    }

    if(type == "idProofUrl"){
      this.idProofUrlLoading = true
    }

    if(type == "addressProofUrl"){
      this.addressProofUrlLoading = true
    }

    if(type == "buildingUrl"){
      this.buildingUrlLoading = true
    }
    this.generic_service.uploadImageEC(file).subscribe((response: any) => {
      if(type == "photoUrl"){
        this.photoUrl = response.response
        this.form.patchValue(
          {photoUrl : response.response}
        )
        this.photoUrlLoading = false

      }

      if(type == "idProofUrl"){
        this.idProofUrl = response.response
        this.form.patchValue(
          {idProofUrl : response.response}
        )
        this.idProofUrlLoading = false

      }

      if(type == "addressProofUrl"){
        this.addressProofUrl = response.response
        this.form.patchValue(
          {addressProofUrl : response.response}
        )
        this.addressProofUrlLoading = false
      }

      if(type == "buildingUrl"){
        this.buildingUrl = response.response
        this.form.patchValue(
          {buildingUrl : response.response}
        )
        this.buildingUrlLoading = false
      }
      },
      (err: any)=>{
        if(type == "photoUrl"){
          this.photoUrlLoading = false
  
        }
  
        if(type == "idProofUrl"){
          this.idProofUrlLoading = false
        }
  
        if(type == "addressProofUrl"){
          this.addressProofUrlLoading = false
        }
  
        if(type == "buildingUrl"){
          this.buildingUrlLoading = false
        }
      }
      
      );
  }


  removeDeviceImage(index:any){
    const myForm = (<FormArray>this.form.get("deviceInfoList")).at(index);
    myForm.patchValue({
      devicePhotoUrl: "",
      devicePhotoUrlLoading: false
    });
  }

  addDeviceImageBtn(index:any){
    let photo = "devicePhotoUrl"+index
    document.getElementById(photo)?.click()
  }

  onChangeDevice(event: any,index:any) {
    // this.file = event.target.files[0];
    this.onUploadDevice(event.target.files[0],index)
  }
  
  onUploadDevice(file:any,index:any) {
    // this.infoList[index].patchValue(
    //   { 
    //     "devicePhotoUrlLoading": true
    //   }
    // )

    const myForm = (<FormArray>this.form.get("deviceInfoList")).at(index);
    myForm.patchValue({
      devicePhotoUrlLoading: true
    });

    
    
    this.generic_service.uploadImageEC(file).subscribe((response: any) => {
      // this.infoList[index].devicePhotoUrl = response.response
      // this.infoList[index].devicePhotoUrlLoading = false

      myForm.patchValue({
        devicePhotoUrl: response.response,
        devicePhotoUrlLoading: false
      });
      });
  }

  updateData(index: number) {

    
  }

  freeInternet(event:any){
    if(event.currentTarget.checked){
      this.isFreeInternet = "Free Internet"
    }else{
      this.isFreeInternet = ""
    }
  }


    get infoList(){
    return this.form.get('deviceInfoList') as FormArray;
  }

  InfoObject(){
    return this.fb.group({
      "deviceId": ['',[Validators.required]],
      "deviceType": ['',[Validators.required]],
      "deviceInfo": [''],
      "devicePhotoUrl": ['',[Validators.required]],
      "deviceLat": [''],
      "deviceLng": [''],
      "devicePhotoUrlLoading" : false
    })
  }

  addDeviceInfoList(){
    this.infoList.push(this.InfoObject())
  }

  removeDeviceInfoList(index: number){
    this.infoList.removeAt(index)
  }









  // private initMap2(): void {
  
  //   this.map = L.map('map2', {
  //     center: this.defaultCenter,
  //     zoom: this.defaultZoom
  //   });
  
  //   const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //     maxZoom: 22,
  //     minZoom: 2,
  //     attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  //   }).addTo(this.map);
  
  //   const drawnItems = L.featureGroup().addTo(this.map);
  //   const drawControl = new L.Control.Draw({
  //     edit: { featureGroup: drawnItems },
  //     draw: {
  //       marker: true,
  //       polygon: false,
  //       polyline: true,
  //       circle: false,
  //       rectangle: false,
  //       circlemarker: false
  //     }
  //   });
  //   this.map.addControl(drawControl);
  // }


updateMarkerIcon() {
  const zoom = this.map.getZoom();
  const newIcon = this.getScaledIcon(zoom);
  this.marker.setIcon(newIcon);
}

getScaledIcon(zoom: number): L.Icon {
  // Calculate size proportionally or by zoom thresholds
  let size = 70; // default size
  if (zoom < 10) size = 30;
  else if (zoom < 13) size = 50;
  else if (zoom < 16) size = 60;
  // else keep 70 or adjust as needed

  return L.icon({
    iconUrl: this.defaultIcon.iconUrl,
    iconSize: [size, size],
    iconAnchor: [2, 2], // You can adjust this if needed for better positioning
    popupAnchor: [0, -2]
  });
}


  imageUrl: any = ""
  imageUrlSelect(url:any){
    this.imageUrl = url
  }

  closeImage(){
    this.imageUrl = ""
  }

  onMarkerClick(data: any){
    console.log(data)
    this.customerData = []
    this.customerData.push(data)
    document.getElementById("viewB")?.click()

  }

}
